import { Box, CircularProgress } from '@mui/material';
import React from 'react';
import { FeatureGate, FeatureType } from '../context/FeatureContext';
import FundOpportunityChatDisclaimer from './fundOpportunityChat/FundOpportunityChatDisclaimer';
import FundOpportunityChatInterface from './fundOpportunityChat/FundOpportunityChatInterface';
import { useFundOpportunityChat } from './fundOpportunityChat/useFundOpportunityChat';

interface FundOpportunityChatProps {
  fundOpportunityId: string;
  advisorMode?: boolean;
}

const FundOpportunityChat: React.FC<FundOpportunityChatProps> = ({
  fundOpportunityId,
  advisorMode,
}) => {
  const chat = useFundOpportunityChat({ fundOpportunityId, advisorMode });

  return (
    <FeatureGate feature={FeatureType.FeatureAiChat}>
      {chat.isLoadingDisclaimer ? (
        <Box
          sx={{
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            minHeight: '220px',
          }}
        >
          <CircularProgress />
        </Box>
      ) : chat.hasAcceptedDisclaimer || chat.allowedForImpersonation ? (
        <FundOpportunityChatInterface
          messages={chat.messages}
          isProcessing={chat.isProcessing}
          addresses={chat.addresses}
          mapBounds={chat.mapBounds}
          showMap={chat.showMap}
          allowedForImpersonation={chat.allowedForImpersonation}
          hasAcceptedDisclaimer={chat.hasAcceptedDisclaimer}
          inputValue={chat.inputValue}
          hasMessages={chat.hasMessages}
          lastMessageSender={chat.lastMessageSender}
          chatContainerRef={chat.chatContainerRef}
          onInputChange={chat.setInputValue}
          onSubmit={chat.handleSubmit}
          onPresetClick={chat.handlePresetClick}
        />
      ) : (
        <FundOpportunityChatDisclaimer
          statusLoadError={chat.statusLoadError}
          isAcceptingDisclaimer={chat.isAcceptingDisclaimer}
          onRetryStatus={chat.fetchDisclaimerStatus}
          onAccept={chat.handleAcceptDisclaimer}
        />
      )}
    </FeatureGate>
  );
};

export default FundOpportunityChat;
